import React from 'react';

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';

import { SnackbarProvider } from 'notistack';

import {
    AuthProvider,
    FetchProvider,
    NavProvider,
    ToastProvider,
    RestApiProvider,
    UserProvider
} from './components/contexts';

import { Routes } from './components/routing';
import { Layout, MenuContext } from './components/layout';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#0a4682"
        },
        secondary: {
            main: "#26734e"
        },
        text: {
            secondary: "#0a4682"
        }
    },
    overrides: {
        MuiStepIcon: {
            root: {
                '&$active': {
                    color: "#0a4682",
                },
                '&$completed': {
                    color: "#d1d1d1",
                },
            },
        },
        MuiSwitch: {
        },
        MuiCheckbox: {
            colorSecondary: {
                color: '#0a4682',
                '&$checked': {
                    color: '#0a4682',
                },
            },
        },
        MuiTabs: {
            indicator: {
                backgroundColor: "#0a4682"
            }
        }
    }
});

const App = (props) => {
    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider preventDuplicate maxSnack={5}>
                <ToastProvider>
                    <AuthProvider>
                        <FetchProvider>
                            <RestApiProvider>
                                <NavProvider>
                                    <UserProvider>
                                        <Layout>
                                            <Routes />
                                        </Layout>
                                    </UserProvider>
                                </NavProvider>
                            </RestApiProvider>
                        </FetchProvider>
                    </AuthProvider>
                </ToastProvider>
            </SnackbarProvider>
        </ThemeProvider>
    );
};

export default App;